<template>
  <span>

      <el-form-item label="ID:" class="query-form-item">
          <el-input style="width: 100px;" clearable v-model="query.id" placeholder="请输入ID" size="mini"></el-input>
      </el-form-item>

      <el-form-item label="是否有专利值:" class="query-form-item">
          <el-select v-model="query.has_patent_value" placeholder="状态" size="mini" style="width: 100px;">
              <el-option label="全部" value=""></el-option>
              <el-option label="有" :value="1"></el-option>
              <el-option label="没有" :value="0"></el-option>
          </el-select>
      </el-form-item>

      <el-form-item label="选品原则：" class="query-form-item">
          <el-select v-model="query.selection_principle" placeholder="选品原则" size="mini" style="width: 100px;">
              <el-option label="全部" value=""></el-option>
              <el-option :label="item.name" :value="item.value"
                         v-for="item in selectionPrincipleList"></el-option>
          </el-select>
      </el-form-item>

      <el-form-item label="标品类型：" class="query-form-item">
          <el-select v-model="query.standard_product_type" placeholder="标品类型" size="mini" style="width: 110px;">
              <el-option label="全部" value=""></el-option>
              <el-option label="未录入" :value="-1"></el-option>
              <el-option :label="item.name" :value="item.value"
                         v-for="item in standardProductTypeArr"></el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="是否季节性：" class="query-form-item" >
          <el-select v-model="query.is_seasonality" placeholder="季节性" size="mini" style="width: 100px;">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
          </el-select>
      </el-form-item>

      <el-form-item label="季节：" class="query-form-item">
          <el-select v-model="query.season" placeholder="请选择" size="mini" filterable style="width: 100px;">
              <el-option :label="item.label" :value="item.value"
                         v-for="item in $common.seasonArr"></el-option>
          </el-select>
      </el-form-item>
  </span>
</template>

<script>
import * as api from '@/api/advAnalys/advAnalys'

export default {
    name: 'formRangeItem',
    props: ['queryTemp'],
    watch: {
        'queryTemp': {
            handler(val) {
                this.query = val
            },
            immediate: true,
            deep: true
        }
    },
    created() {
        this.initFunc()
    },
    data() {
        return {
            query: {},
            selectionPrincipleList: [],
            standardProductTypeArr: [
                {name: '标品-大众', value: '标品-大众'},
                {name: '标品-小众', value: '标品-小众'},
                {name: '非标-大众', value: '非标-大众'},
                {name: '非标-小众', value: '非标-小众'},
            ],
        }
    },
    methods: {
        initFunc() {
            api.cost_analysis_selfbuild_get_selection_principle().then(res => {
                this.loading = false
                if (res.code === 0) {
                    this.selectionPrincipleList = (res.data || []).map(item => {
                        return {name: item, value: item}
                    })
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).catch(() => {
                this.loading = false
            })
        },
    }
}
</script>

